"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M389 235.7c-12.5-17.1-12.5-40.4 0-57.6 25-34.2-2.5-81.8-44.6-77.2-21.1 2.3-41.3-9.3-49.8-28.8-17.1-38.8-72.1-38.8-89.2 0-8.6 19.4-28.7 31.1-49.8 28.8-42.1-4.6-69.6 43-44.6 77.2 12.5 17.1 12.5 40.4 0 57.6-25 34.2 2.5 81.8 44.6 77.2 21.1-2.3 41.3 9.3 49.8 28.8 17.1 38.8 72.1 38.8 89.2 0 8.6-19.4 28.7-31.1 49.8-28.8 42.1 4.6 69.6-43.1 44.6-77.2zm-139 45.5c-41 0-74.3-33.3-74.3-74.3s33.3-74.3 74.3-74.3 74.3 33.3 74.3 74.3-33.3 74.3-74.3 74.3z"
  }), (0, _core.jsx)("circle", {
    cx: 250,
    cy: 206.9,
    r: 55.7
  }), (0, _core.jsx)("path", {
    d: "M188.4 349.1c-4.8-10.9-15.6-18-27.6-18-1.1 0-2.2.1-3.3.2-2.6.3-5.1.4-7.6.4-4.5 0-9-.6-13.3-1.5L95 402.4c-1.9 3.3-1.6 7.3.7 10.3 2.3 3 6.1 4.3 9.8 3.3l54.4-14.6 14.6 54.4c1 3.6 4 6.3 7.8 6.8.4.1.8.1 1.2.1 3.3 0 6.4-1.7 8-4.6l41.1-71.2c-19.5-5-35.7-18.5-44.2-37.8zM363.3 330.3c-4.3.9-8.8 1.5-13.3 1.5-2.5 0-5-.1-7.6-.4-1.1-.1-2.2-.2-3.3-.2-11.9 0-22.8 7.1-27.6 18-8.5 19.2-24.7 32.7-44.1 37.8l41.1 71.2c1.7 2.9 4.8 4.6 8 4.6.4 0 .8 0 1.2-.1 3.7-.5 6.8-3.2 7.8-6.8l14.6-54.4 54.4 14.6c3.6 1 7.5-.3 9.8-3.3s2.6-7 .7-10.3l-41.7-72.2z"
  }));
};

exports.default = _default;